jQuery(function($) {

  if (!$(".faqs").length) return;

  var expandableContent = $(".faqs");
  var toggles = expandableContent.find("h3");

  // Function to recalculate heights
  function recalculateHeights() {
    toggles.each(function() {
      var toggle = $(this);
      var content = toggle.next(".expandable");
      var height = content[0].scrollHeight;
      content.attr("data-height", height);

      // If the toggle is open, update the height
      if (toggle.hasClass("open")) {
        content.css("height", height);
      }
    });
  }

  // Initial calculation of heights
  recalculateHeights();

  // Recalculate heights on window resize
  $(window).resize(function() {
    recalculateHeights();
  });

  toggles.click(function() {
    var toggle = $(this);
    var content = toggle.next(".expandable");

    if (!toggle.hasClass("open")) {
      // Remove open class from all other faqs and reset height of all other content
      toggles.not(toggle).removeClass("open").parent().removeClass('open');
      toggles.not(toggle).next(".expandable").css("height", 0);

      toggle.addClass("open").parent().addClass('open');
      content.css("height", content.attr("data-height"));

      // Loop through siblings and add data-order attribute based on how far from the clicked toggle they are
      toggle.parent().siblings('.faq').each(function() {
        var sibling = $(this);
        var order = sibling.index() - toggle.parent().index();

        // Convert negative number to positive
        if (order < 0) {
          order = order * -1;
        }

        sibling.attr("data-order", order).addClass('closed');
        toggle.parent().attr("data-order", 0);
      });

      return;
    } else {
      toggle.removeClass("open").parent().removeClass('open');
      content.css("height", 0);
      // Remove class closed from all siblings
      toggle.parent().siblings('.faq').removeClass('closed');

      //hide all other faqs
      // toggles.not(toggle).removeClass("open");
      // toggle.toggleClass("open");
    }
  });
});
